const WholesaleSection = () => {
  const whatsappNumber = '50661025212';
  const whatsappMessage = encodeURIComponent(
    'Hola! Me interesa información sobre distribución al por mayor de productos de skincare. ¿Podrían enviarme precios y condiciones especiales?'
  );
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section id="distribucion" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20luxury%20skincare%20products%20organized%20on%20modern%20white%20shelves%20in%20a%20clean%20distribution%20warehouse%2C%20premium%20imported%20La%20Roche-Posay%20cosmetics%20neatly%20arranged%2C%20professional%20business%20atmosphere%20with%20soft%20natural%20lighting%20and%20minimalist%20white%20and%20beige%20tones&width=1920&height=1080&seq=wholesale2cr&orientation=landscape"
          alt="Distribución al por mayor Costa Rica"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/60 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Info */}
          <div>
            <div className="inline-block px-5 py-2 border border-[#D4AF37]/60 rounded-full mb-6">
              <span className="text-[#D4AF37] text-sm font-light">Venta al Por Mayor</span>
            </div>
            <h2 className="font-['Playfair_Display'] text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
              Distribuí Skincare de Calidad en Costa Rica
            </h2>
            <p className="text-xl text-white/85 font-light leading-relaxed mb-8">
              Ofrecemos precios especiales para spas, estéticas, farmacias y revendedores en todo el país.
            </p>
            <div className="space-y-4">
              {[
                'Productos 100% originales de distribuidores autorizados',
                'Precios competitivos para distribuidores y revendedores',
                'Amplio catálogo de La Roche-Posay y otras marcas premium',
                'Envíos a todo Costa Rica',
                'Asesoría personalizada para tu negocio'
              ].map((item) => (
                <div key={item} className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-[#D4AF37] text-xl"></i>
                  </div>
                  <p className="text-white/80 text-base font-light">{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: WhatsApp CTA Card */}
          <div className="bg-white/95 backdrop-blur-sm p-10 rounded-3xl flex flex-col items-center text-center">
            {/* Icon */}
            <div className="w-20 h-20 flex items-center justify-center bg-[#25D366]/10 rounded-full mb-6">
              <i className="ri-whatsapp-line text-4xl text-[#25D366]"></i>
            </div>

            <h3 className="font-['Playfair_Display'] text-3xl font-bold text-gray-900 mb-3">
              Hablemos Directamente
            </h3>
            <p className="text-gray-500 text-base font-light mb-2 leading-relaxed max-w-sm">
              Escribinos por WhatsApp y recibí atención personalizada con precios y condiciones especiales para tu negocio.
            </p>

            {/* Divider */}
            <div className="w-16 h-px bg-[#D4AF37]/40 my-6"></div>

            {/* Benefits */}
            <div className="grid grid-cols-3 gap-4 w-full mb-8">
              {[
                { icon: 'ri-time-line', label: 'Respuesta rápida' },
                { icon: 'ri-shield-check-line', label: 'Trato directo' },
                { icon: 'ri-price-tag-3-line', label: 'Precios especiales' },
              ].map((b) => (
                <div key={b.label} className="flex flex-col items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FAF8F5] rounded-full">
                    <i className={`${b.icon} text-lg text-gray-700`}></i>
                  </div>
                  <span className="text-gray-600 text-xs font-light leading-tight">{b.label}</span>
                </div>
              ))}
            </div>

            {/* WhatsApp Button */}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white text-base font-semibold rounded-full hover:bg-[#1ebe5d] transition-all duration-300 shadow-lg hover:shadow-[#25D366]/30 hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl"></i>
              </div>
              Contactar por WhatsApp
            </a>

            <p className="text-gray-400 text-xs font-light mt-4">
              +506 6102-5212 · Lunes a Sábado, 8am – 6pm
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WholesaleSection;
